export const TelemetryNamespace = { Portal: { TrackTrace: 'uipath.portal.track-trace' } };
